module.exports = __webpack_public_path__ + "iconfont.0730922d9e0b2e028267.svg";


//////////////////
// WEBPACK FOOTER
// D:/taile-operate/BLACK-WIDOW/ng-src/assets/iconfont/projectIconfont/iconfont.svg?t=1483974170613
// module id = ../../../../../ng-src/assets/iconfont/projectIconfont/iconfont.svg?t=1483974170613
// module chunks = styles